// extracted by mini-css-extract-plugin
export default {"wrapper":"Onboarding-module__wrapper___5FaLx","close":"Onboarding-module__close___Z+ZLF","tint":"Onboarding-module__tint___JQt2f","content":"Onboarding-module__content___3gUIe"};